import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FinanceInvoiceListDialogModel } from './model';
import { PopupService } from 'src/app/core/services/popup/popup.service';
import { FinanceService } from 'src/app/core/services/api/finance.service';

@Component({
  selector: 'app-finance-invoice-list',
  templateUrl: './finance-invoice-list.component.html',
  styleUrls: ['./finance-invoice-list.component.scss']
})
export class FinanceInvoiceListComponent implements OnInit {
  invoices = [];
  page = 0;

  constructor(
    public dialogRef: MatDialogRef<FinanceInvoiceListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FinanceInvoiceListDialogModel,
    private financeService: FinanceService,
    private popupService: PopupService
  ) {}


  ngOnInit(): void {
    this.popupService.openProgress();
    this.getInvoices();
  }

  getInvoices() {
    const params = {
      piIds: this.data.debitNote.sellerInvoiceNumberList,
      page: this.page
    }
    this.financeService.getInvoices(params).subscribe(
      response => {
        this.invoices = response.data;
        this.popupService.closeProgress();
      },
      error => {
        this.popupService.closeProgress();
        this.popupService.openError(error.error.error.error);
      }
    )
  }

  getNextPage() {
    this.popupService.openProgress();
    this.page++;
    this.getInvoices();
  }

  getPreviousPage() {
    this.popupService.openProgress();
    this.page--;
    this.getInvoices();
  }

  close() {
    this.dialogRef.close();
  }

}
